import { cn } from '@/lib/utils';

export const Kbd = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
    <kbd
        className={cn(
            'inline-flex h-5 min-w-5 items-center justify-center rounded border bg-card px-1 font-sans text-[0.75rem] font-semibold text-muted-foreground shadow-[0_1px_0_0_hsl(var(--border))]',
            className
        )}
        {...props}
    />
);
